import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ItemCharacteristicStateDataFragment = { __typename?: 'ItemCharacteristicStateData', itemCharacteristicId: string };

export type AddItemCharacteristicMutationVariables = Types.Exact<{
  input: Types.AddItemCharacteristicInput;
}>;


export type AddItemCharacteristicMutation = { __typename?: 'Mutation', addItemCharacteristic: { __typename?: 'ItemCharacteristicPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null, itemCharacteristic?: { __typename?: 'ItemCharacteristicStateData', itemCharacteristicId: string } | null } };

export type UpdateItemCharacteristicMutationVariables = Types.Exact<{
  input: Types.UpdateItemCharacteristicInput;
}>;


export type UpdateItemCharacteristicMutation = { __typename?: 'Mutation', updateItemCharacteristic: { __typename?: 'ItemCharacteristicPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null, itemCharacteristic?: { __typename?: 'ItemCharacteristicStateData', itemCharacteristicId: string } | null } };

export type DeleteItemCharacteristicMutationVariables = Types.Exact<{
  input: Types.DeleteItemCharacteristicInput;
}>;


export type DeleteItemCharacteristicMutation = { __typename?: 'Mutation', deleteItemCharacteristic: { __typename?: 'ItemCharacteristicPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null, itemCharacteristic?: { __typename?: 'ItemCharacteristicStateData', itemCharacteristicId: string } | null } };

export type UndeleteItemCharacteristicMutationVariables = Types.Exact<{
  input: Types.UndeleteItemCharacteristicInput;
}>;


export type UndeleteItemCharacteristicMutation = { __typename?: 'Mutation', undeleteItemCharacteristic: { __typename?: 'ItemCharacteristicPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null, itemCharacteristic?: { __typename?: 'ItemCharacteristicStateData', itemCharacteristicId: string } | null } };

export type AddItemCharacteristicValueMutationVariables = Types.Exact<{
  input: Types.AddItemCharacteristicValueInput;
}>;


export type AddItemCharacteristicValueMutation = { __typename?: 'Mutation', addItemCharacteristicValue: { __typename?: 'ItemCharacteristicPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null, itemCharacteristic?: { __typename?: 'ItemCharacteristicStateData', itemCharacteristicId: string } | null } };

export type UpdateItemCharacteristicValueMutationVariables = Types.Exact<{
  input: Types.UpdateItemCharacteristicValueInput;
}>;


export type UpdateItemCharacteristicValueMutation = { __typename?: 'Mutation', updateItemCharacteristicValue: { __typename?: 'ItemCharacteristicPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null, itemCharacteristic?: { __typename?: 'ItemCharacteristicStateData', itemCharacteristicId: string } | null } };

export type DeleteItemCharacteristicValueMutationVariables = Types.Exact<{
  input: Types.DeleteItemCharacteristicValueInput;
}>;


export type DeleteItemCharacteristicValueMutation = { __typename?: 'Mutation', deleteItemCharacteristicValue: { __typename?: 'ItemCharacteristicPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null, itemCharacteristic?: { __typename?: 'ItemCharacteristicStateData', itemCharacteristicId: string } | null } };

export type UndeleteItemCharacteristicValueMutationVariables = Types.Exact<{
  input: Types.UndeleteItemCharacteristicValueInput;
}>;


export type UndeleteItemCharacteristicValueMutation = { __typename?: 'Mutation', undeleteItemCharacteristicValue: { __typename?: 'ItemCharacteristicPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null, itemCharacteristic?: { __typename?: 'ItemCharacteristicStateData', itemCharacteristicId: string } | null } };

export const ItemCharacteristicStateDataFragmentDoc = new TypedDocumentString(`
    fragment ItemCharacteristicStateData on ItemCharacteristicStateData {
  itemCharacteristicId
}
    `, {"fragmentName":"ItemCharacteristicStateData"});
export const AddItemCharacteristicDocument = new TypedDocumentString(`
    mutation AddItemCharacteristic($input: AddItemCharacteristicInput!) {
  addItemCharacteristic(input: $input) {
    errors {
      ...RecordValidationError
    }
    itemCharacteristic {
      ...ItemCharacteristicStateData
    }
  }
}
    fragment ItemCharacteristicStateData on ItemCharacteristicStateData {
  itemCharacteristicId
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const UpdateItemCharacteristicDocument = new TypedDocumentString(`
    mutation UpdateItemCharacteristic($input: UpdateItemCharacteristicInput!) {
  updateItemCharacteristic(input: $input) {
    errors {
      ...RecordValidationError
    }
    itemCharacteristic {
      ...ItemCharacteristicStateData
    }
  }
}
    fragment ItemCharacteristicStateData on ItemCharacteristicStateData {
  itemCharacteristicId
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const DeleteItemCharacteristicDocument = new TypedDocumentString(`
    mutation DeleteItemCharacteristic($input: DeleteItemCharacteristicInput!) {
  deleteItemCharacteristic(input: $input) {
    errors {
      ...RecordValidationError
    }
    itemCharacteristic {
      ...ItemCharacteristicStateData
    }
  }
}
    fragment ItemCharacteristicStateData on ItemCharacteristicStateData {
  itemCharacteristicId
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const UndeleteItemCharacteristicDocument = new TypedDocumentString(`
    mutation UndeleteItemCharacteristic($input: UndeleteItemCharacteristicInput!) {
  undeleteItemCharacteristic(input: $input) {
    errors {
      ...RecordValidationError
    }
    itemCharacteristic {
      ...ItemCharacteristicStateData
    }
  }
}
    fragment ItemCharacteristicStateData on ItemCharacteristicStateData {
  itemCharacteristicId
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const AddItemCharacteristicValueDocument = new TypedDocumentString(`
    mutation AddItemCharacteristicValue($input: AddItemCharacteristicValueInput!) {
  addItemCharacteristicValue(input: $input) {
    errors {
      ...RecordValidationError
    }
    itemCharacteristic {
      ...ItemCharacteristicStateData
    }
  }
}
    fragment ItemCharacteristicStateData on ItemCharacteristicStateData {
  itemCharacteristicId
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const UpdateItemCharacteristicValueDocument = new TypedDocumentString(`
    mutation UpdateItemCharacteristicValue($input: UpdateItemCharacteristicValueInput!) {
  updateItemCharacteristicValue(input: $input) {
    errors {
      ...RecordValidationError
    }
    itemCharacteristic {
      ...ItemCharacteristicStateData
    }
  }
}
    fragment ItemCharacteristicStateData on ItemCharacteristicStateData {
  itemCharacteristicId
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const DeleteItemCharacteristicValueDocument = new TypedDocumentString(`
    mutation DeleteItemCharacteristicValue($input: DeleteItemCharacteristicValueInput!) {
  deleteItemCharacteristicValue(input: $input) {
    errors {
      ...RecordValidationError
    }
    itemCharacteristic {
      ...ItemCharacteristicStateData
    }
  }
}
    fragment ItemCharacteristicStateData on ItemCharacteristicStateData {
  itemCharacteristicId
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const UndeleteItemCharacteristicValueDocument = new TypedDocumentString(`
    mutation UndeleteItemCharacteristicValue($input: UndeleteItemCharacteristicValueInput!) {
  undeleteItemCharacteristicValue(input: $input) {
    errors {
      ...RecordValidationError
    }
    itemCharacteristic {
      ...ItemCharacteristicStateData
    }
  }
}
    fragment ItemCharacteristicStateData on ItemCharacteristicStateData {
  itemCharacteristicId
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddItemCharacteristic: build.mutation<AddItemCharacteristicMutation, AddItemCharacteristicMutationVariables>({
      query: (variables) => ({ document: AddItemCharacteristicDocument, variables })
    }),
    UpdateItemCharacteristic: build.mutation<UpdateItemCharacteristicMutation, UpdateItemCharacteristicMutationVariables>({
      query: (variables) => ({ document: UpdateItemCharacteristicDocument, variables })
    }),
    DeleteItemCharacteristic: build.mutation<DeleteItemCharacteristicMutation, DeleteItemCharacteristicMutationVariables>({
      query: (variables) => ({ document: DeleteItemCharacteristicDocument, variables })
    }),
    UndeleteItemCharacteristic: build.mutation<UndeleteItemCharacteristicMutation, UndeleteItemCharacteristicMutationVariables>({
      query: (variables) => ({ document: UndeleteItemCharacteristicDocument, variables })
    }),
    AddItemCharacteristicValue: build.mutation<AddItemCharacteristicValueMutation, AddItemCharacteristicValueMutationVariables>({
      query: (variables) => ({ document: AddItemCharacteristicValueDocument, variables })
    }),
    UpdateItemCharacteristicValue: build.mutation<UpdateItemCharacteristicValueMutation, UpdateItemCharacteristicValueMutationVariables>({
      query: (variables) => ({ document: UpdateItemCharacteristicValueDocument, variables })
    }),
    DeleteItemCharacteristicValue: build.mutation<DeleteItemCharacteristicValueMutation, DeleteItemCharacteristicValueMutationVariables>({
      query: (variables) => ({ document: DeleteItemCharacteristicValueDocument, variables })
    }),
    UndeleteItemCharacteristicValue: build.mutation<UndeleteItemCharacteristicValueMutation, UndeleteItemCharacteristicValueMutationVariables>({
      query: (variables) => ({ document: UndeleteItemCharacteristicValueDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddItemCharacteristicMutation, useUpdateItemCharacteristicMutation, useDeleteItemCharacteristicMutation, useUndeleteItemCharacteristicMutation, useAddItemCharacteristicValueMutation, useUpdateItemCharacteristicValueMutation, useDeleteItemCharacteristicValueMutation, useUndeleteItemCharacteristicValueMutation } = injectedRtkApi;
